import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { H3, ModalHeader, ModalBody, ModalFooter, Submit, Button, Form, Input } from '@framework'
import { rejectWithdrawal } from '@store/actions/transaction.action'

class RejectWihtdrawalModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      reason: '',
      requestId: props.requestId
    }
  }

  handleInputChange (state, event) {
    this.setState({ [state]: event.target.value })
  }

  render () {
    const { rejectWithdrawal, modal } = this.props
    const { reason } = this.state

    return (
      <Form onSubmit={rejectWithdrawal.bind(this, this.state)}>
        <ModalHeader color='danger'>
          <H3>Give a Reason</H3>
        </ModalHeader>
        <ModalBody>
          <Input label='Reason' value={reason}
            onChange={this.handleInputChange.bind(this, 'reason')} />
        </ModalBody>
        <ModalFooter>
          <Submit color='danger' disabled={!reason}>Reject</Submit>
          <Button onClick={() => modal.hide()}>Cancel</Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default connect(
  ({ transaction:
    { pendingWithdrawalRequests: {
      requestId
    } },
  }) => ({
    requestId
  }), 
  dispatch => bindActionCreators({
    rejectWithdrawal
  }, dispatch)
  )(RejectWihtdrawalModal)
